import { render, staticRenderFns } from "./LocaleChanger.vue?vue&type=template&id=b9e896fe&"
import script from "./LocaleChanger.vue?vue&type=script&lang=ts&"
export * from "./LocaleChanger.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports